import React from "react";
import styles from "./RecipeSuggestions.module.css";
import { Recipe } from "types/recipe";

// Import assets
import recipeImage from "../../assets/52c80c70af664c053cc40edc7663c3fc7ca4280e.png";
import timeIcon from "../../assets/537_11346.svg";
import starFilled from "../../assets/537_11342.svg";
import starHalf from "../../assets/537_11343.svg";
import starEmpty from "../../assets/537_11344.svg";

// Icons for the 5-star rating bar
import starRating1 from "../../assets/542_2210.svg";
import starRating2 from "../../assets/542_2211.svg";
import starRating3 from "../../assets/542_2212.svg";
import starRating4 from "../../assets/542_2213.svg";
import starRating5 from "../../assets/542_2214.svg";

// Add icon for the main button
import addIcon from "../../assets/537_11292.svg";

// Mock data generators for missing fields
// const mockPrice = () => `€${(Math.random() * 30 + 10).toFixed(2)}`;
const mockCookTime = (minutes?: number) =>
  `${minutes || Math.floor(Math.random() * 40 + 10)} min`;
// const mockTags = () => {
//   const possibleTags = ["Spicy", "Vegan", "Gluten-Free", "Low-Carb", "Organic"];
//   return [possibleTags[Math.floor(Math.random() * possibleTags.length)]];
// };

// Simplified Props
interface RecipeSuggestionsProps {
  // Main ways to get a recipe
  recipe?: Recipe | null;
  recipeIndex?: number;
  recipesData?: Recipe[];

  // Callback for add button
  onAddToCart: (id: string) => void;

  // Default values for missing data
  defaultName?: string;
  defaultImageUrl?: string;
  defaultRating?: number;

  // Styling
  className?: string;
  style?: React.CSSProperties;
}

const RecipeSuggestions: React.FC<RecipeSuggestionsProps> = ({
  recipe: directRecipe,
  onAddToCart,
  defaultName = "Penne mit Lachs-Zitronen-Sauce",
  defaultImageUrl = recipeImage,
  defaultRating = 4.5,
  className,
  style,
}) => {
  // Simple recipe selection logic - use direct recipe or select from recipesData
  let selectedRecipe: Recipe | null = directRecipe || null;

  // Extract data with fallbacks
  const recipeName = selectedRecipe?.name || defaultName;
  const recipeId = selectedRecipe?.recipeId || "suggestion-placeholder-id";

  // Get the image URL - properly handle the recipeImage object
  const imageUrl =
    selectedRecipe?.recipeImage?.large ||
    selectedRecipe?.recipeImage?.small ||
    defaultImageUrl;

  // Mock or extract supplementary data
  // const price = mockPrice();
  const cookTime = mockCookTime(selectedRecipe?.preparationTime);
  // const tags = selectedRecipe?.categories?.length
  //   ? [selectedRecipe.categories[0].name]
  //   : selectedRecipe?.difficulty
  //   ? [selectedRecipe.difficulty]
  //   : mockTags();
  // const rating = selectedRecipe?.rating ?? defaultRating;

  // Render stars based on rating
  const renderRatingStars = (rating: number) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < 3; i++) {
      if (i < fullStars) {
        stars.push(<img key={i} src={starFilled} alt="Star" />);
      } else if (i === fullStars && hasHalfStar) {
        stars.push(<img key={i} src={starHalf} alt="Star" />);
      } else {
        stars.push(<img key={i} src={starEmpty} alt="Star" />);
      }
    }

    return stars;
  };

  const spoons = (() => {
    const diffuculty = selectedRecipe?.difficulty?.toLowerCase() as string;
    switch (diffuculty) {
      case "easy":
        return 1;
      case "medium":
        return 2;
      case "hard":
        return 3;
      default:
        return undefined;
    }
  })();

  return (
    <div
      className={`${styles.frame47353711270} ${className || ""}`}
      style={style}
    >
      {/* Image Section with overlays */}
      <div className={styles.imageContainer5422203}>
        <img
          src={imageUrl}
          alt={recipeName}
          className={styles.recipeImage5422203}
        />

        {/* 5-Star Rating Bar */}
        <div className={styles.frame452542209}>
          <img src={starRating1} alt="Rating Star" />
          <img src={starRating2} alt="Rating Star" />
          <img src={starRating3} alt="Rating Star" />
          <img src={starRating4} alt="Rating Star" />
          <img src={starRating5} alt="Rating Star" />
        </div>

        {/* Section below image */}
        <div className={styles.frame45553711340}>
          {/* Rating Stars */}
          <div className={styles.ratingStars53711341}>
            {spoons && renderRatingStars(spoons)}
          </div>
          {/* Time Tag */}
          <div className={styles.timeTagContainer53711345}>
            <img src={timeIcon} alt="Time" />
            <span className={styles.timeText53711347}>{cookTime}</span>
          </div>
        </div>
      </div>

      {/* Text Content Area - Title -> Tags -> Price */}
      <div className={styles.textContentArea}>
        {/* Title */}
        <p className={styles.titleText53711283}>{recipeName}</p>

        {/* Tags Area */}
        {/* <div className={styles.tagsArea}>
          {tags.map((tag: string, index: number) => (
            <span
              key={index}
              className={`${styles.tagBase} ${
                styles[`tag${tag.replace(/[\s-]/g, "")}`]
              }`}
            >
              {tag}
            </span>
          ))}
        </div> */}

        {/* Price */}
        {/* <p className={styles.priceText53711289}>{price}</p> */}
      </div>

      {/* Add Button */}
      <button
        className={styles.addToCartButton53711290}
        onClick={() => onAddToCart(recipeId)}
      >
        <img
          src={addIcon}
          alt="Add to cart"
          className={styles.addToCartIcon53711292}
        />
      </button>
    </div>
  );
};

export default RecipeSuggestions;
